import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { OwnershipLevel } from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'ownership-level',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './ownership-level.component.html',
})
export class OwnershipLevelComponent {
  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);

  ownershipLevel = OwnershipLevel;

  constructor() {}

  ngOnInit(): void {}
}
